import { splashPrefs } from "@app/cookies.server";
import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { homePageMockData } from "@modules/home/data/mockData";
import { HomePage } from "@modules/home/pages";
import { trans } from "@mongez/localization";
import type { LoaderFunction, MetaFunction } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";

export const loader: LoaderFunction = async ({ request, params }) => {
  const { catchErrors } = await getLoaderEndpoint(request);

  const cookieHeader = request.headers.get("cookie");
  const cookies = (await splashPrefs.parse(cookieHeader)) || {};

  if (!cookies.hasSeenSplash) {
    cookies.hasSeenSplash = false;
  }

  try {
    // Return clean mock data from separate file
    return json(
      { ...homePageMockData, hasSeenSplash: cookies.hasSeenSplash },
      {
        headers: {
          "Set-Cookie": await splashPrefs.serialize(cookies),
        },
      },
    );
  } catch (error) {
    console.log("Error: ", error);
    return catchErrors(error);
  }
};

export default function HomeIndex() {
  const data = useLoaderData<typeof loader>();

  return <HomePage data={data} />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.meta?.title || trans("homePage.title"),
    description: data?.meta?.description || trans("homePage.description"),
  });
};
